module.exports = __webpack_public_path__ + "media/team_photos/Michelle-Steiger-photo-da9ecb47.webp";